import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { ChargingDeviceIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";

export const IncreaseExpectedElectricLoaderForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.INCREASE_EXPECTED_ELECTRIC_LOADER_V2>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<ChargingDeviceIcon />}
                content={
                    <Fragment>
                        <p className={classes.label} style={{ marginBottom: 8 }}>
                            Ladeeinrichtung
                        </p>
                    </Fragment>
                }
                useSwitch={
                    <Switch
                        checked={values.increaseExpectedElectricLoaderV2.value.yes}
                        {...getFieldProps("adjustableLoadElectricLoaderV2.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.increaseExpectedElectricLoaderV2.value.yes = checked;
                                values.increaseExpectedElectricLoaderV2.value.no = !checked;
                            })
                        }
                    />
                }
                detailCondition={values.increaseExpectedElectricLoaderV2.value.yes}
                detail={
                    <p className={classes.p}>
                        Nachdem Sie diesen Antrag für Ihre Leistungserhöhung abgesendet haben,
                        erfassen Sie bitte einen weiteren Antrag über den Prozess "Verbrauchsgeräte,
                        z.B. Ladeeinrichtung, Wärmepumpe, Gerät zur Raumkühlung".
                    </p>
                }
            />
        </Fragment>
    );
};
